import React, { Fragment } from 'react';

import classes from './aboutUs.module.css';
import Photo from '../../Data/mountains.jpg';
import PersonalData from '../../Data/DevsData';
import SocialLinks from '../SocialLinks/SocialLinks';
import { useSelector } from 'react-redux';
const AboutMe = () => {

    const uiColor=useSelector(state=>state.uiColor);

    return (
        <Fragment>
            <div className={classes.contactMe}>
                <div className={classes.avatar}>
                    <img src={Photo} alt="" style={{borderColor:uiColor}} />
                </div>
                <div className={classes.contactCard}>
                    <h1 style={{color:uiColor}}>About Us</h1>
                    <div>
                        {PersonalData.aboutMe}
                    </div>
                    <div className={classes.contactLinks}>
                        <SocialLinks className={classes.links} />
                    </div>
                    <div>
                        We are a small open source community that puts security and optimazation on top of everything, our discord server link is : https://discord.gg/kYStRKBHwy and contact us on this email : firebrowserdevs@gmail.com or in contact page 
                    </div>
                </div>
            </div>
        </Fragment>
    )
};
export default AboutMe;